module.exports = __webpack_public_path__ + "img/de.3e726c2b.svg";